import * as React from "react";
import { IconButton, TextField } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import FormControl from "@mui/material/FormControl";
import { useCallback, useRef } from "react";

interface IFooterChatComponentProps {
  buttons: string[];
  handleChatSubmit: (message: string) => void;
  enabledInput: boolean;
}

export const FooterChatComponent: React.FC<IFooterChatComponentProps> = (
  { buttons, handleChatSubmit, enabledInput },
) => {
  const [message, setMessage] = React.useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setMessage(e.target.value);
  }, []);

  const handleSubmit = useCallback((e?: React.FormEvent) => {
    e?.preventDefault();

    if (buttons.length > 0) {
      handleChatSubmit(buttons.join(", "));
      setMessage("");
      return;
    }

    if (message.trim() !== "") {
      handleChatSubmit(message);
      setMessage("");
    }
  }, [message, handleChatSubmit, buttons]);

  return (
    <FormControl
      fullWidth
      variant="standard"
      sx={{ backgroundColor: "#f5f5f5" }}
    >
      <div className="fixed bottom-0 w-full bg-[#f5f5f5]">
        <div className="relative">
          <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-t from-[#D2D4DA] to-[#F4F4F6]"></div>
          <div className="flex items-center bg-white p-2 border">
            <TextField
              multiline
              hiddenLabel
              fullWidth
              color="warning"
              maxRows={4}
              placeholder="Digite sua mensagem"
              ref={inputRef}
              value={message}
              onChange={handleChange}
              disabled={!enabledInput}
            />
            <div className="ml-2">
              <IconButton
                type={"submit"}
                onClick={handleSubmit}
                className="p-2"
                aria-label="Enviar message"
                sx={{
                  backgroundColor: "#fa5a50",
                  "&:hover": {
                    backgroundColor: "#6e0600ff",
                  },
                }}
              >
                <SendIcon fontSize="inherit" sx={{ color: "white" }} />
              </IconButton>
            </div>
          </div>
        </div>
      </div>
    </FormControl>
  );
};
